import { memo } from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Element form of `defaultChildRoute`, for an index route that must render
 * something else first and can no longer redirect from its loader.
 */
export const DefaultChildRedirect = memo(function DefaultChildRedirect({
  child,
}: {
  child: string;
}) {
  const { pathname, search } = useLocation();
  return (
    <Navigate
      replace
      to={{ pathname: `${pathname.replace(/\/+$/, "")}/${child}`, search }}
    />
  );
});
